/*
 * @Author: mkRui 1102163949@qq.com
 * @Date: 2025-10-12 16:20:10
 * @LastEditors: mkRui 1102163949@qq.com
 * @LastEditTime: 2025-11-04 17:51:24
 * @FilePath: /polordar-explorer/lib/i18n/LanguageContext.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';

import * as cookies from 'lib/cookies';

type Language = 'en' | 'zh';

type Dict = Record<string, string>;

interface LanguageContextValue {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string) => string;
}

const LanguageContext = React.createContext<LanguageContextValue | null>(null);

function loadDict(lang: Language): Dict {
  try {
    // Static imports to allow tree-shaking in Next
    if (lang === 'zh') {
      return {
        ...require('./locales/zh/common.json'),
        ...require('./locales/zh/settings.json'),
        ...require('./locales/zh/pages.json'),
        ...require('./locales/zh/verifiedContracts.json'),
        ...require('./locales/zh/nav.json'),
        ...require('./locales/zh/footer.json'),
        ...require('./locales/zh/internalTxs.json'),
      };
    }

    return {
      ...require('./locales/en/common.json'),
      ...require('./locales/en/settings.json'),
      ...require('./locales/en/pages.json'),
      ...require('./locales/en/verifiedContracts.json'),
      ...require('./locales/en/nav.json'),
      ...require('./locales/en/footer.json'),
      ...require('./locales/en/internalTxs.json'),
    };
  } catch (e) {
    return {};
  }
}

export function LanguageProvider({ children, initialLang }: { children: React.ReactNode; initialLang?: Language }) {
  const [ lang, setLangState ] = React.useState<Language>(initialLang || (cookies.get(cookies.NAMES.LANGUAGE) as Language) || 'en');
  const [ dict, setDict ] = React.useState<Dict>(() => loadDict(lang));

  const setLang = React.useCallback((next: Language) => {
    setLangState(next);
    cookies.set(cookies.NAMES.LANGUAGE, next);
    setDict(loadDict(next));
  }, []);

  const t = React.useCallback((key: string) => {
    return dict[key] || key;
  }, [ dict ]);

  const value = React.useMemo(() => ({ lang, setLang, t }), [ lang, setLang, t ]);

  return (
    <LanguageContext.Provider value={ value }>
      { children }
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const ctx = React.useContext(LanguageContext);
  if (!ctx) {
    return { t: (key: string) => key, lang: 'en' as Language, setLang: () => {} };
  }
  return ctx;
}
